// On a phone the program's days stay stuck below the pinned top (global.css). A new choice made
// further down, past the pills: the new day starts just under them, and the days keep a screen's
// room, so a shorter day doesn't pull the page back up under the reader; short of them, the room
// to stay where the reader is (Seán, 2026-10-29: no jumps).
import {nextTick, watch} from "vue";

const GAP = 8; // the pills' background below them (global.css: 0.5rem)

const getPills = (daysElement) => daysElement.parentElement.querySelector(".dayTags");

// where the pills' bottom edge sits once stuck: their sticky top and their height. Not measured
// where they are: the old days leave out of the flow, so the table ends early and, for a moment,
// carries them up with its end
const getStuckBottom = (pills) => parseFloat(getComputedStyle(pills).top) + pills.offsetHeight;

// the reader is past the pills (they're stuck)
function getIsPastPills(daysElement) {
  if (!document.body.classList.contains("isPinnedTop")) return false;
  const pills = getPills(daysElement);
  if (!pills) return false;
  return daysElement.getBoundingClientRect().top < pills.getBoundingClientRect().bottom + GAP;
}

// short of the pills (a short program): the table's room enough to stay where the reader is, as
// the old days leave out of the flow and the legend above them can lose a line
function getRoomToStay(tableElement) {
  const below = document.documentElement.scrollHeight - window.innerHeight - window.scrollY;
  return Math.max(tableElement.offsetHeight - below, 0);
}

// daysRef: the days' container; shownDays: the days it shows
export default function useKeepDaysInView(daysRef, shownDays) {
  watch(shownDays, async () => {
    const daysElement = daysRef.value;
    if (!daysElement) return;
    const isPastPills = getIsPastPills(daysElement);
    const stuckBottom = isPastPills ? getStuckBottom(getPills(daysElement)) : 0;
    const tableElement = daysElement.parentElement;
    const roomToStay = isPastPills ? 0 : getRoomToStay(tableElement);
    tableElement.style.minHeight = roomToStay ? `${roomToStay}px` : "";
    daysElement.style.minHeight = isPastPills ? `${window.innerHeight - stuckBottom}px` : "";
    if (!isPastPills) return;
    await nextTick();
    const offset = daysElement.getBoundingClientRect().top - getStuckBottom(getPills(daysElement));
    const top = Math.round(window.scrollY + offset - GAP); // whole pixels: WebKit settles a part
    window.scrollTo({top, behavior: "instant"});
  }, {flush: "pre"});
}
